<div
  class="mbs-loader"
  [class]="bgClass()">
  <div class="d-flex flex-column align-items-center">
    <div
      class="mbs-loader_spinner"
      [class]="spinnerClasses()"></div>
    @if (text(); as text) {
      <div class="mt-3">
        {{ text }}
      </div>
    }
  </div>
</div>
